import * as React from "react";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { Box, Checkbox, TableCell, Tooltip } from "@mui/material";
import { ListStateIconShare } from "source/components/framework/List/ListStateIconShare";

export interface IValidationErrorDictionary {
  [key: string]: string[];
}

export interface ITableRow {
    taskType: ITaskEditTypeItem;
    dataRow: ITaskDataRow;
    dataRowInvisibleColErrors?: IValidationErrorDictionary;
    dataRowErrors?: IValidationErrorDictionary;
    divider?: boolean;
}

export interface IReportExcelReportTableRowDataProp {
    tableRow: ITableRow;
    multiSelect: boolean;
    checkedIds: string[];
    onSetCheckedIds: (ids: string[]) => void;
}

export const ReportExcelReportTableRowData = (props: IReportExcelReportTableRowDataProp) => {
    const isChecked = props.multiSelect && !!props.tableRow.dataRow && props.checkedIds?.includes(props.tableRow.dataRow.id);

    const handleCheck = (id: string) => {
        const checkedIds = props.checkedIds.filter(i => i !== props.tableRow.dataRow.id);
        if (!isChecked) {
            checkedIds.push(props.tableRow.dataRow.id);
        }
        if (!props.onSetCheckedIds) return;
        props.onSetCheckedIds(checkedIds);
    };

    return (
        <>
            {props.tableRow.taskType.lineCols.map((dataCol, index) => {
                if (props.tableRow.dataRow) {
                    const uiValue = props.tableRow.dataRow.getTaskDataRowColListUiValue(dataCol.field, props.tableRow.taskType);
                    let tooltip = uiValue.text;
                    const rowHasErrors = Object.keys(props.tableRow.dataRowErrors || {}).length > 0;
                    const colErrors = rowHasErrors && props.tableRow.dataRowErrors[dataCol.field];
                    const colHasErrors = colErrors && colErrors.length > 0;
                    if (colHasErrors) {
                        tooltip = colErrors.join(",");
                    }
                    const cellContent = <>
                        {(props.multiSelect && !!props.tableRow.dataRow && index === 0 &&
                            <Checkbox
                                color="primary"
                                checked={isChecked}
                                //disabled={validationRow && validationRow.cols.some(i => i.errors.length > 0)}
                                disabled={rowHasErrors}
                                sx={{ marginLeft: "-5px", marginRight: "5px", padding: "0" }}
                                onChange={() => handleCheck(props.tableRow.dataRow.id)}
                            />
                        )}
                        {(uiValue.icon && uiValue.icon.name === "ListStateIconShare"
                            ? <>
                                <Box sx={{ overflow: "hidden" }}>{uiValue.text}</Box>
                                <Box sx={{ marginLeft: "auto" }}><ListStateIconShare tooltip={uiValue.icon.tooltip} /></Box>
                            </>
                            : uiValue.text
                        )}
                    </>;
                    return <Tooltip
                        title={tooltip}
                        key={dataCol.field}>
                        <TableCell
                            className={dataCol.class}
                            sx={{
                                textOverflow: "clip",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                backgroundColor: colHasErrors ? "error.main" : null
                            }}
                        >
                            {(!uiValue.icon
                                ? cellContent
                                : <Box sx={{ display: "flex", alignItems: "center", marginRight: "-15px" }}>
                                    {cellContent}
                                </Box>
                            )}
                        </TableCell>
                    </Tooltip>;
                } else {
                    if (!props.tableRow.divider) {
                        return <TableCell
                            key={dataCol.field}
                            className={dataCol.class}
                            sx={{ textOverflow: "clip", overflow: "hidden", whiteSpace: "nowrap", backgroundColor: "action.hover" }}
                        >
                            {dataCol.title}
                        </TableCell>;
                    } else {
                        return <TableCell
                            key={dataCol.field}
                            className={dataCol.class}
                            sx={{ textOverflow: "clip", overflow: "hidden", whiteSpace: "nowrap" }}
                        >
                            &nbsp;
                        </TableCell>;
                    }
                }
            })}
        </>
    );
};